export interface DmTourSection {
    id: string;
    title: string;
    html?: string;
    controlsLoaded?: boolean;
}
